var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-6"},[_c('div',{staticClass:"lg:w-3/4 lg:mx-auto"},[_c('p',{staticClass:"font-bold text-lg"},[_vm._v("Biodata Form")]),(_vm.underwriterId === 1)?_c('ChiForm'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }